import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useSearchParams } from 'react-router-dom';
import { Provider, useSelector } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './store/store';

// Routes
import AppRoutes from './routes';

// Components
import Toast from './components/common/Toast';
import Loader from './components/common/Loader';
import ThemeProvider from './themes/ThemeProvider';

// Hooks
import { useInitializeApp } from './hooks/useInitializeApp';

// Global Styles
import './assets/styles/globals.css';

const AuthHandoff = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const authToken = searchParams.get('auth_token');
    const authRefresh = searchParams.get('auth_refresh');
    const authUser = searchParams.get('auth_user');

    if (authToken && authRefresh && authUser) {
      localStorage.setItem('token', decodeURIComponent(authToken));
      localStorage.setItem('refreshToken', decodeURIComponent(authRefresh));
      localStorage.setItem('user', decodeURIComponent(authUser));
      window.history.replaceState({}, document.title, '/terminal');
      window.location.reload();
    }
  }, []);

  return null;
};

const AppContent = () => {
  const { isAuthenticated } = useSelector((state) => state.auth);

  useInitializeApp();

  return (
    <ThemeProvider>
      <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden">
        <div className="g1" />
        <div className="g2" />
      </div>
      <AuthHandoff />
      <AppRoutes />
      <Toast />
    </ThemeProvider>
  );
};

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={<Loader message="Loading Groxion Platform" />} persistor={persistor}>
        <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <AppContent />
        </Router>
      </PersistGate>
    </Provider>
  );
}

export default App;